import {baseUrl} from 'common/js/http/pdBase'

export default {
  data () {
    return {
      isSearch: false,
      searchList: [],
      searchMessage: {
        url: '/ensearch/prompt/',
        data: 'filter.searchmatter',
        fun: 'search'
      },
      searchTime: null
    }
  },
  mounted () {
    if (this.searchChangeMessage) {
      Object.assign(this.searchMessage, this.searchChangeMessage)
    }
  },
  methods: {
    clearSearch () {
      setTimeout(() => {
        this.isSearch = false
        // this.searchList = []
      }, 250)
    },
    clickSearch () {
      this.isSearch = true
      // this.searchList = []
    },
    getSearchList () {
      const name = eval('this.' + this.searchMessage.data) || '_all'
      if (name) {
        this.$pdAxios({
          method: 'post',
          url: this.searchMessage.url + name,
          baseURL: baseUrl
        })
          .then((data) => {
            if (data.data.errCode === 200) {
              const list = data.data.data
              this.searchList = list
            }
          })
      }
    },
    changeSearchList () {
      if (this.searchTime) {
        clearTimeout(this.searchTime)
      }
      this.searchTime = setTimeout(() => {
        this.getSearchList()
      }, 500)
    },
    changeSearchEntity (name) {
      const _name = this.searchMessage.data.split('.')
      if (_name && _name.length > 1) {
        this.$set(this[_name[0]], _name[1], name)
      } else {
        this.$set(this, _name[0], name)
      }
      eval('this.' + this.searchMessage.fun + '()')
      this.clearSearch()
      setTimeout(() => {
        clearTimeout(this.searchTime)
      })
    }
  }
}
